import {
    Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Breadcrumb, BreadcrumbItem, Container,
    Card, CardBody, CardTitle, CardFooter
} from 'reactstrap';
import React, { useState, useRef, Component } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ReporteDespachoService from "./ReporteDespachoService"
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { default as MuiInput } from '@mui/material/Input';

import { FaPallet } from 'react-icons/fa';
import { FaBoxes } from 'react-icons/fa';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

import { ReporteDespachoChart } from "./ReporteDespachoChart"

import authService from '../api-authorization/AuthorizeService'

export class HomeAdmin_Index extends Component {
    static displayName = HomeAdmin_Index.name;
    constructor(props) {
        super(props);
        var today = new Date();
        var week = today.getWeek().toString();
        var year = today.getFullYear().toString();
        this.state = {
            data: [],
            eventos: [],
            yearData:[],
            loading: true,
            searchModel: { nombre: "", week: week, year: year, destinos: [] },
            destinos: [],
            reporteDespachoData: {},
            date: new Date()
        };
        this.load_weekData = this.load_weekData.bind(this);
        this.populateData = this.populateData.bind(this);
        this.dateChange = this.dateChange.bind(this);
    }

    componentDidMount() {
        this.populateData();
    }

    modalToggle() {
        this.setState({
            modalState: !this.state.modalState
        });
    }

    ITEM_HEIGHT = 48;
    ITEM_PADDING_TOP = 8;
    MenuProps = {
        PaperProps: {
            style: {
                maxHeight: this.ITEM_HEIGHT * 4.5 + this.ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };
    getPaletasTotales = () => {
        return this.state.data.length;
    }
    getCajasTotales = () => {
        const sum = this.state.data.reduce((accumulator, object) => {
            return accumulator + object.cajasPorPaleta;
        }, 0);
        return sum;
    }
    getContenedoresTotales = () => {
        var sum = this.state.data.map((item) => item.contenedor)
            .filter((value, index, self) => self.indexOf(value) === index).length;
        //console.log(this.state.data);
/*        var sum = [...new Set(this.state.data.map(item => item.contenedores))].length;*/
        return sum;
    }

    renderTable() {
        console.log("eventos", this.state.eventos);
        return (
            <div  >
                <h1 className="mb-4 ms-4">Bienvenido</h1>
                <div className="d-flex">
                    <div className="me-5">
                        <Calendar name='date' locale='es' className="calendar shadow-sm p-3 mb-5 bg-white " value={this.state.date} showWeekNumbers onChange={this.dateChange} />
                    </div>
                    <div  className="dateCard ms-5">
                        <div style={{
                            fontSize: 64
                        }}>{this.state.date.getWeek()}</div>
                        <h4>{this.state.date.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })} | {this.state.date.toLocaleDateString('es-ES', { year: 'numeric' })}</h4>
                        {this.state.eventos.map(evento => { return (<p>{evento.descripcion}</p>) })}
                    </div>
                    
                </div>
                <Row className="">
                    {/*<h2 className="mb-4 ms-4">Contenedores por destino</h2>*/}
                    <div className="col col-md-3 ">
                        <h3 className="mb-4 ms-4">Resumen Semanal</h3>
                        <Card
                            className="my-2"
                            style={{
                                maxWidth: '18rem', textAlign: 'center', backgroundColor: '#324a68', color: 'white'
                            }}
                        >
                            <CardBody>
                                <div className="d-flex justify-content-around">
                                    <h1><LocalShippingIcon fontSize="large" style={{ color: '#7387a2' }} /></h1>
                                    <div>
                                        Contenedores
                                        <CardTitle tag="h4">
                                            {this.getContenedoresTotales()}
                                        </CardTitle>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <Card
                            className="my-2"
                            style={{
                                maxWidth: '18rem', textAlign: 'center', backgroundColor: '#25675D', color: 'white'
                            }}
                        >
                            <CardBody>
                                <div className="d-flex justify-content-around">
                                    <h1><FaPallet style={{ color: '#52877D' }} /></h1>
                                    <div>
                                        Paletas
                                        <CardTitle tag="h4">
                                            {this.getPaletasTotales()}
                                        </CardTitle>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <Card
                            className="my-2"
                            style={{
                                maxWidth: '18rem', textAlign: 'center', backgroundColor: '#B8895F', color: 'white'
                            }}
                        >
                            <CardBody>
                                <div className="d-flex justify-content-around">
                                    <h1><FaBoxes style={{ color: '#C6A27E' }} /></h1>
                                    <div>
                                        Cajas
                                        <CardTitle tag="h4">
                                            {this.getCajasTotales()}
                                        </CardTitle>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                    <div className="col col-md-9">
                        <ReporteDespachoChart data={this.state.reporteDespachoData} />
                    </div>
                </Row>
                <Row>
                    
                </Row>
                <Modal isOpen={this.state.modalState} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>
                        {this.state.modalHeader}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.modalBody}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.modalSubmit} disabled={!this.state.modalIsValid}>
                            {this.state.modalOperation == 'delete' ? <FormattedMessage id='Eliminar' /> : <FormattedMessage id='Guardar' />}
                        </Button>{' '}
                        <Button color="secondary" onClick={this.modalToggle}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Cargando...</em></p>
            : this.renderTable();

        return (
            <div className="viewContainer-lg">
                
                {contents}

            </div>
        );
    }

    async populateData() {
        this.setState({ loading: true }, async () => {
            var today = new Date();
            var week = today.getWeek().toString();
            var year = today.getFullYear().toString();
            const token = await authService.getAccessToken();
           
            const response = await fetch('api/reporteDespacho/anual?year=' + year, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            });
            const responseData = await response.json();
            console.log("Anual", responseData);
            this.setState({ reporteDespachoData: responseData, eventos: await this.load_eventos(), data: await this.load_weekData(), loading: false });
        });
    }
    async load_weekData() {
        var week = this.state.date.getWeek().toString();
        var year = this.state.date.getFullYear().toString();
        const token = await authService.getAccessToken();

        const response = await fetch('api/reporteDespacho?year=' + year + '&week=' + week + '&destinos=none', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        });
        return await response.json();
    }
    async load_eventos() {
        var week = this.state.date.getWeek().toString();
        var year = this.state.date.getFullYear().toString();
        const token = await authService.getAccessToken();

        const response = await fetch('api/eventosSemanales?semana=' + year + '-' +week, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        });
        return await response.json();
    }

    dateChange(value) {
        this.setState({
            date: value
        }, async () => {
            this.setState({
                data: await this.load_weekData(),
                eventos: await this.load_eventos(),
            });
        });
    }
 

}